import Intro from "./sections/Intro";
import Request from "./sections/Request";

export default function Blackhat({ event }) {
  return (
    <>
      <div className="events-wrapper deal-wrapper event-series-wrapper blackhat-wrapper redesign">
        <Intro event={event} />
        <Request event={event} />
      </div>
    </>
  );
}
